const GridColSettingConstants = {
  GET_COL_SETTING_SUCCESS: "GET_COL_SETTING_SUCCESS",
  GET_COL_SETTING_FAILURE: "GET_COL_SETTING_FAILURE",

  SAVE_GRID_SETTING_SUCCESS: "SAVE_GRID_SETTING_SUCCESS",
  SAVE_GRID_SETTING_FAILURE: "SAVE_GRID_SETTING_FAILURE",

  GET_SAVE_FILTER_LIST_SUCCESS: "GET_SAVE_FILTER_LIST_SUCCESS",
  GET_SAVE_FILTER_LIST_FAILURE: "GET_SAVE_FILTER_LIST_FAILURE",

  GET_SAVE_FILTER_LIST_OVERDUE_SUCCESS: "GET_SAVE_FILTER_LIST_OVERDUE_SUCCESS",
  GET_SAVE_FILTER_LIST_OVERDUE_FAILURE: "GET_SAVE_FILTER_LIST_OVERDUE_FAILURE",

  GET_SAVE_FILTER_LIST_NIO_SUCCESS: "GET_SAVE_FILTER_LIST_NIO_SUCCESS",
  GET_SAVE_FILTER_LIST_NIO_FAILURE: "GET_SAVE_FILTER_LIST_NIO_FAILURE",

  GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_SUCCESS:
    "GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_SUCCESS",
  GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_FAILURE:
    "GET_SAVE_FILTER_LIST_ORDER_OVERVIEW_FAILURE",

  GET_SAVE_FILTER_LIST_INACTIVE_SUCCESS:
    "GET_SAVE_FILTER_LIST_INACTIVE_SUCCESS",
  GET_SAVE_FILTER_LIST_INACTIVE_FAILURE:
    "GET_SAVE_FILTER_LIST_INACTIVE_FAILURE",

  GET_SAVE_FILTER_VALUE_SUCCESS: "GET_SAVE_FILTER_VALUE_SUCCESS",
  GET_SAVE_FILTER_VALUE_FAILURE: "GET_SAVE_FILTER_VALUE_FAILURE",

  GET_SAVE_FILTER_VALUE_OVERDUE_OVER__SUCCESS:
    "GET_SAVE_FILTER_VALUE_OVERDUE_OVER__SUCCESS",
  GET_SAVE_FILTER_VALUE_OVERDUE_OVER_FAILURE:
    "GET_SAVE_FILTER_VALUE_OVERDUE_OVER_FAILURE",

  GET_SAVE_FILTER_NIO_SUCCESS: "GET_SAVE_FILTER_NIO_SUCCESS",
  GET_SAVE_FILTER_NIO_FAILURE: "GET_SAVE_FILTER_NIO_FAILURE",

  GET_SAVE_FILTER_INACTIVE_VALUE_SUCCESS:
    "GET_SAVE_FILTER_INACTIVE_VALUE_SUCCESS",
  GET_SAVE_FILTER_INACTIVE_VALUE_FAILURE:
    "GET_SAVE_FILTER_INACTIVE_VALUE_FAILURE",

  GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS:
    "GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_SUCCESS",
  GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_FAILURE:
    "GET_SAVE_FILTER_ORDER_OVERVIEW_VALUE_FAILURE",

  GET_SAVE_FILTER_BULK_UPADTE_VALUE_SUCCESS:
    "GET_SAVE_FILTER_BULK_UPADTE_VALUE_SUCCESS",
  GET_SAVE_FILTER_BULK_UPADTE_VALUE_FAILURE:
    "GET_SAVE_FILTER_BULK_UPADTE_VALUE_FAILURE",

  GET_SAVE_FILTER_MESSAGE_VALUE_SUCCESS:
    "GET_SAVE_FILTER_MESSAGE_VALUE_SUCCESS",
  GET_SAVE_FILTER_MESSAGE_VALUE_FAILURE:
    "GET_SAVE_FILTER_MESSAGE_VALUE_FAILURE",

  GET_SAVE_FILTER_OVERDUE_SUCCESS: "GET_SAVE_FILTER_OVERDUE_SUCCESS",
  GET_SAVE_FILTER_OVERDUE_FAILURE: "GET_SAVE_FILTER_OVERDUE_FAILURE",

  GET_SAVE_FILTER_NIO_SUCCESS: "GET_SAVE_FILTER_NIO_SUCCESS",
  GET_SAVE_FILTER_NIO_FAILURE: "GET_SAVE_FILTER_NIO_FAILURE",

  GET_SAVE_FILTER_ORDER_OVERVIEW_SUCCESS:
    "GET_SAVE_FILTER_ORDER_OVERVIEW_SUCCESS",
  GET_SAVE_FILTER_ORDER_OVERVIEW_FAILURE:
    "GET_SAVE_FILTER_ORDER_OVERVIEW_FAILURE",

  GET_SAVE_FILTER_INACTIVE_SUCCESS: "GET_SAVE_FILTER_INACTIVE_SUCCESS",
  GET_SAVE_FILTER_INACTIVE_FAILURE: "GET_SAVE_FILTER_INACTIVE_FAILURE",

  GET_EQUI_LIST_ON_FILTER_SUCCESS: "GET_EQUI_LIST_ON_FILTER_SUCCESS",
  GET_EQUI_LIST_ON_FILTER_FAILURE: "GET_EQUI_LIST_ON_FILTER_FAILURE",

  GET_EQUI_LIST_ON_OVERDUE_SUCCESS: "GET_EQUI_LIST_ON_OVERDUE_SUCCESS",
  GET_EQUI_LIST_ON_OVERDUE_FAILURE: "GET_EQUI_LIST_ON_OVERDUE_FAILURE",

  GET_EQUI_LIST_ON_NIO_SUCCESS: "GET_EQUI_LIST_ON_NIO_SUCCESS",
  GET_EQUI_LIST_ON_NIO_FAILURE: "GET_EQUI_LIST_ON_NIO_FAILURE",

  GET_EQUI_LIST_ON_ORDER_OVERVIEW_SUCCESS:
    "GET_EQUI_LIST_ON_ORDER_OVERVIEW_SUCCESS",
  GET_EQUI_LIST_ON_ORDER_OVERVIEW_FAILURE:
    "GET_EQUI_LIST_ON_ORDER_OVERVIEW_FAILURE",

  GET_EQUI_LIST_ON_INACTIVE_SUCCESS: "GET_EQUI_LIST_ON_INACTIVE_SUCCESS",
  GET_EQUI_LIST_ON_INACTIVE_FAILURE: "GET_EQUI_LIST_ON_INACTIVE_FAILURE",

  DEL_SAVED_FILTER_SUCCESS: "DEL_SAVED_FILTER_SUCCESS",
  DEL_SAVED_FILTER__FAILURE: "DEL_SAVED_FILTER__FAILURE",

  SAVE_GRID_SETTING_OVERDUE_SUCCESS: "SAVE_GRID_SETTING_OVERDUE_SUCCESS",
  SAVE_GRID_SETTING_OVERDUE_FAILURE: "SAVE_GRID_SETTING_OVERDUE_FAILURE",

  SAVE_GRID_SETTING_NIO_SUCCESS: "SAVE_GRID_SETTING_NIO_SUCCESS",
  SAVE_GRID_SETTING_NIO_FAILURE: "SAVE_GRID_SETTING_NIO_FAILURE",

  SAVE_GRID_SETTING_ORDER_OVERVIEW_SUCCESS:
    "SAVE_GRID_SETTING_ORDER_OVERVIEW_SUCCESS",
  SAVE_GRID_SETTING_ORDER_OVERVIEW_FAILURE:
    "SAVE_GRID_SETTING_ORDER_OVERVIEW_FAILURE",

  SAVE_GRID_SETTING_INACTIVE_SUCCESS: "SAVE_GRID_SETTING_INACTIVE_SUCCESS",
  SAVE_GRID_SETTING_INACTIVE_FAILURE: "SAVE_GRID_SETTING_INACTIVE_FAILURE",

  SAVE_GRID_FILTER_SUCCESS: "SAVE_GRID_FILTER_SUCCESS",
  SAVE_GRID_FILTER_FAILURE: "SAVE_GRID_FILTER_FAILURE",

  SAVE_GRID_FILTER_OVERDUE_SUCCESS: "SAVE_GRID_FILTER_OVERDUE_SUCCESS",
  SAVE_GRID_FILTER_OVERDUE_FAILURE: "SAVE_GRID_FILTER_OVERDUE_FAILURE",

  SAVE_GRID_FILTER_NIO_SUCCESS: "SAVE_GRID_FILTER_NIO_SUCCESS",
  SAVE_GRID_FILTER_NIO_FAILURE: "SAVE_GRID_FILTER_NIO_FAILURE",

  SAVE_GRID_FILTER_ORDER_OVERVIEW_SUCCESS:
    "SAVE_GRID_FILTER_ORDER_OVERVIEW_SUCCESS",
  SAVE_GRID_FILTER_ORDER_OVERVIEW_FAILURE:
    "SAVE_GRID_FILTER_ORDER_OVERVIEW_FAILURE",
  SAVE_GRID_FILTER_INACTIVE_SUCCESS: "SAVE_GRID_FILTER_INACTIVE_SUCCESS",
  SAVE_GRID_FILTER_INACTIVE_FAILURE: "SAVE_GRID_FILTER_INACTIVE_FAILURE",
};
export default GridColSettingConstants;
